import { getUserLang } from '@/i18n/utils';

export const normalizePrice = (price: number | string) => {
  const cleanPrice =
    typeof price === 'string' ? parseFloat(price.replace('$', '')) : price;

  return (
    new Intl.NumberFormat(getUserLang().detectedValue, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      currencyDisplay: 'narrowSymbol'
    })
      .format(cleanPrice)
      .replace('$', '')
      .trim() + ' USD'
  );
};

export const normalizePriceDollar = (price: number | string) => {
  if (!price) return '-';
  const cleanPrice =
    typeof price === 'string' ? parseFloat(price.replace('$', '')) : price;

  return (
    '$' +
    new Intl.NumberFormat(getUserLang().detectedValue, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      currencyDisplay: 'narrowSymbol'
    })
      .format(cleanPrice)
      .replace('$', '')
      .trim()
  );
};

/**
 * 格式化数字：添加千分位分隔符，大数使用k/M/B表示
 * @param num 要格式化的数字
 * @returns 格式化后的字符串
 */
export const formatNumber = (num: number | string) => {
  if (num === undefined || num === null) return 'N/A';
  const numValue = typeof num === 'string' ? parseFloat(num) : num;
  if (isNaN(numValue) || numValue < 0) return 'N/A';

  const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 1,
    minimumFractionDigits: 0
  });

  const absNum = Math.abs(numValue);
  const sign = numValue < 0 ? '-' : '';

  if (absNum >= 1000000000) {
    return `${sign}${formatter.format(absNum / 1000000000)}B`;
  } else if (absNum >= 1000000) {
    return `${sign}${formatter.format(absNum / 1000000)}M`;
  } else if (absNum >= 1000) {
    return `${sign}${formatter.format(absNum / 1000)}K`;
  } else {
    return formatter.format(numValue);
  }
};
